import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedOnHoldsOrders: [],
};

const onHoldSlice = createSlice({
	name: 'onHoldOrders',
	initialState: initialState,
	reducers: {
		setOnHoldOrders: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setOnHoldOrders, reset } = onHoldSlice.actions;

export default onHoldSlice.reducer;